<template>
  <SpaceSettingsEditModalTemplate @close="$emit('close')">
    <template v-slot:title>{{ $t('editTitle') }}</template>
    <template v-slot:form>
      <AccountCreateForm :edit_item="edit_item"
                         @cancelEdit="$emit('close')"/>
    </template>
  </SpaceSettingsEditModalTemplate>
</template>

<script>
import AccountCreateForm from "@/components/cabinet/SpaceSettings/AccountsSettings/AccountsSettingsForm";
import SpaceSettingsEditModalTemplate from "@/components/UI/SpaceSettings/SpaceSettingsEditModalTemplate";

export default {
  name: "AccountsSettingsEditModal",
  components: {
    SpaceSettingsEditModalTemplate,
    AccountCreateForm,
  },
  props: {
    edit_item: {
      type: Object,
      required: true
    }
  },
  i18n: {
    messages: {
      en: {
        editTitle: 'Account edit'
      },
      ru: {
        editTitle: 'Редактирование счета'
      }
    }
  }
}
</script>